<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Summary Komisi</div>
		</div>
		<template v-if="loading">
			<div class="d-flex flex-wrap">
				<v-col cols="12" class="px-0">
					<v-row>
						<v-col cols="12" sm="12" md="4" xl="4" class="pb-0" v-for="i in 3" :key="i+10">
							<v-card class="elevation-0 rounded-xl">
								<vcl :width='300' :height='90'>
									<rect x="30" y="30" rx="20" ry="20" width="40" height="40" />
									<rect x="90" y="30" rx="2" ry="2" width="110" height="20" />
									<rect x="90" y="60" rx="2" ry="2" width="150" height="20" />
								</vcl>
							</v-card>
						</v-col>
						<v-col cols="12" sm="12">
							<v-card class="elevation-0 rounded-xl mt-3" v-for="i in 2" :key="i">
								<vcl :height='30'>
									<rect x="8" y="12" rx="2" ry="2" width="55" height="10" />
									<rect x="105" y="8" rx="2" ry="2" width="45" height="8" />
									<rect x="105" y="20" rx="2" ry="2" width="65" height="8" />
									<rect x="205" y="8" rx="2" ry="2" width="45" height="8" />
									<rect x="205" y="20" rx="2" ry="2" width="65" height="8" />
									<rect x="305" y="8" rx="2" ry="2" width="45" height="8" />
									<rect x="305" y="20" rx="2" ry="2" width="65" height="8" />
								</vcl>
							</v-card>
						</v-col>
					</v-row>
				</v-col>
			</div>
		</template>

		<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
			<template v-if="!loading">
				<div class="d-flex flex-wrap">
					<v-col cols="12" class="pr-0 pl-0 pt-0">
						<v-card
							color="#385F73"
							dark
							class="mt-5 rounded-xl"
							outlined
						>
							<v-card-subtitle class="font-size-12">
								Informasi Batas Transfer
							</v-card-subtitle>
							<v-card-text>
								<v-row>
									<v-col cols="12" sm="12" md="4">
										<v-card
											elevation="0"
											outlined
											light
											color="#fff"
											class="rounded-xl"
										>
											<v-card-text>
												<span class="d-block mb-3" style="line-height: normal;">Total Limit Transfer / Batas Transfer<br>Untuk ID Anda</span>
												<!-- <div class="font-size-13 font-weight-bold d-block mb-1" style="color: #385F73;">{{ (summaryKomisi.clone.length * limitTransfer) | toRupiah }}</div> -->
												<div class="font-size-13 font-weight-bold d-block mb-1" style="color: #385F73;">{{ summaryKomisi.master.totalLimit | toRupiah }}</div>
											</v-card-text>
										</v-card>
									</v-col>
									<v-col cols="12" sm="12" md="4">
										<v-card
											elevation="0"
											outlined
											light
											color="#fff"
											class="rounded-xl"
										>
											<v-card-text>
												<span class="d-block mb-3" style="line-height: normal;">Total Komisi yang Didapat<br>Untuk ID Anda</span>
												<div class="font-size-13 font-weight-bold d-block mb-1" style="color: #385F73;">{{ summaryKomisi.master.totalAcc | toRupiah }}</div>
											</v-card-text>
										</v-card>
									</v-col>
									<v-col cols="12" sm="12" md="4">
										<v-card
											elevation="0"
											outlined
											light
											color="#fff"
											class="rounded-xl"
										>
											<v-card-text>
												<span class="d-block mb-3" style="line-height: normal;">Total Komisi yang Telah Ditransfer<br>Untuk ID Anda</span>
												<div class="font-size-13 font-weight-bold d-block mb-1" style="color: #385F73;">{{ summaryKomisi.master.totalPaid | toRupiah }}</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" class="pr-0 pl-0 pt-0">
						<v-card
							color="#385F73"
							dark
							class="mt-3 rounded-xl"
							outlined
						>
							<v-card-subtitle class="font-size-12">
								Informasi Total Komisi
							</v-card-subtitle>
							<v-card-text>
								<v-row>
									<template v-for="komisi in summaryKomisi.master.arrBonus">
										<v-col cols="12" sm="12" md="4" :key="komisi.label" v-if="komisi.label !== 'Pasangan Menunggu'">
											<v-card
												elevation="0"
												outlined
												light
												color="#fff"
												class="rounded-xl"
											>
												<v-card-text>
													<span class="d-block mb-3" style="line-height: normal;">Total Komisi {{ komisi.label }}</span>
													<div class="font-size-13 font-weight-bold d-block mb-1" style="color: #385F73;">{{ komisi.acc | toRupiah }}</div>
												</v-card-text>
											</v-card>
										</v-col>
									</template>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" class="pr-0 pl-0 pt-0">
						<div class="font-size-12 cl-dark-green font-weight-bold" v-if="false">Potensi Komisi</div>
						<template	v-if="false">
							<v-row justify="start" class="mt-1 mb-3 ml-0" v-if="summaryKomisi.potency">
								<v-col cols="12" sm="12" md="6" xl="6" class="pl-0" v-for="(potency, idk) in summaryKomisi.potency" :key="idk">
									<v-card class="pa-4 elevation-0 rounded-xl hover-shadow teal lighten-4">
										<v-row>
											<v-col cols="12">
												<div class="font-size-10 cl-dark-green font-weight-500">{{ potency.label }}</div>
												<div class="font-size-13 cl-dark-green font-weight-500">{{ potency.value | toRupiah }}</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>
						</template>

						<!-- Informasi komisi titik utama -->
						<div class="pt-5" v-if="false">
							<div class="font-size-12 cl-dark-green font-weight-bold">Kode Mitra {{ userData.member_network_code }}</div>
							<v-row justify="center" class="mt-1 mb-2 ml-0">
								<v-col cols="12" sm="12" md="4" xl="4" class="pl-0">
									<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow cyan darken-1">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right align-center">
												<img class="img-fluid filter-white" src="/assets/icon/total-bonus.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div class="font-size-13 white--text font-weight-600">{{ summaryKomisi.master.totalAcc | toRupiah }}</div>
												<div class="font-size-10 white--text font-weight-bold">Total Diperoleh</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
								<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3 pl-0">
									<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow teal lighten-2" v-if="false">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
												<img class="img-fluid filter-white" src="/assets/icon/total-dibayarkan.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div class="font-size-13 white--text font-weight-600">{{ summaryKomisi.master.totalPaid | toRupiah }}</div>
												<div class="font-size-10 white--text font-weight-bold">Total Dibayarkan</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
								<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3 pl-0">
									<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow amber darken-2" v-if="false">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
												<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div class="font-size-13 white--text font-weight-600">{{ summaryKomisi.master.totalBalance | toRupiah }}</div>
												<div class="font-size-10 white--text font-weight-bold">Total Saldo Komisi</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<template v-for="(komisi, idx) in summaryKomisi.master.arrBonus">
								<v-card class="px-4 py-3 elevation-0 rounded-xl hover-shadow" :class="{'mt-3': (idx > 0)}" :key="idx + 'a'">
									<v-row>
										<template v-if="komisi.label == 'Reward'">
											<v-col cols="12" sm="12" md="12" class="my-auto flex-column">
												<div class="d-block">
													<div>
														<div class="font-size-12 cl-primary font-weight-500">Komisi {{komisi.label}}</div>

														<v-list outlined rounded dense one-line class="mt-3 rounded-xl">
															<template v-if="komisi.reward.length > 0">
																<template v-for="(item, index) in komisi.reward">
																	<v-list-item
																		:key="index"
																		class=""
																	>
																		<v-list-item-content class="pa-0">
																			<v-list-item-title>
																				<!-- desktop view -->
																				<v-row class="d-none d-sm-none d-md-flex">
																					<v-col cols="12" sm="12" md="6" class="text-left font-size-12">
																						<v-icon dense color="grey" class="mr-2">mdi-circle</v-icon> Reward Peringkat <b>{{ item.reward_qualified_reward_title }}</b> {{ item.reward_qualified_condition_node_left }} : {{ item.reward_qualified_condition_node_left }}
																					</v-col>
																					<v-col cols="12" sm="12" md="6" class="text-right">
																						<div class="font-size-12 dark--text text--darken-1 font-weight-500">{{ item.reward_qualified_reward_value | toRupiah }}</div>
																					</v-col>
																				</v-row>

																				<!-- mobile view -->
																				<v-row class="d-flex d-sm-flex d-md-none">
																					<v-col cols="12" sm="12" md="6" class="d-flex flex-row text-left font-size-10">
																						<v-icon dense color="grey" class="mr-2">mdi-circle</v-icon>
																						<span class="font-size-10">Reward Peringkat <b>{{ item.reward_qualified_reward_title }}</b> {{ item.reward_qualified_condition_node_left }} : {{ item.reward_qualified_condition_node_left }}</span>
																					</v-col>
																					<v-col cols="12" sm="12" md="6" class="text-right">
																						<div class="font-size-10 dark--text text--darken-1 font-weight-500">{{ item.reward_qualified_reward_value | toRupiah }}</div>
																					</v-col>
																				</v-row>
																			</v-list-item-title>
																		</v-list-item-content>
																	</v-list-item>
																</template>
															</template>

															<template v-else>
																<v-list-item>
																	<v-list-item-content class="pa-0">
																		<v-list-item-title>
																			<v-row>
																				<v-col cols="12" sm="12" md="12" class="text-center font-size-10">
																					<span class="d-block text-muted grey--text">Belum ada informasi komisi reward yang tersedia.</span>
																				</v-col>
																			</v-row>
																		</v-list-item-title>
																	</v-list-item-content>	
																</v-list-item>
															</template>
														</v-list>

													</div>
												</div>
											</v-col>
										</template>

										<template v-else>
											<v-col cols="12" sm="12" md="4" class="my-auto flex-column">
												<div class="d-flex">
													<div>
														<div class="font-size-9 cl-grey">Komisi</div>
														<div class="font-size-12 cl-primary font-weight-500">{{komisi.label}}</div>
													</div>
													<div class="mt-auto" v-if="komisi.detail == 1">
														<v-btn small depressed color="primary" class="ml-3 white--text rounded-xl text-capitalize" @click="gotoKomisiTeam">Detail</v-btn>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-none d-md-flex">
												<v-row>
													<v-col cols="12" sm="12" md="12" class="pt-0 pt-sm-3 my-auto text-right">
														<div class="font-size-10 cl-grey">Diperoleh</div>
														<div class="font-size-12 cyan--text text--darken-1 font-weight-500">{{ komisi.acc | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto" v-if="false">
														<div class="font-size-10 cl-grey">Dibayarkan</div>
														<div class="font-size-12 teal--text text-lighten-2 font-weight-500">{{ komisi.paid | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right" v-if="false">
														<div class="font-size-10 cl-grey">Saldo</div>
														<div class="font-size-12 cl-primary font-weight-500">{{ komisi.saldo | toRupiah }}</div>
													</v-col>
												</v-row>
											</v-col>

											<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-flex d-md-none">
												<v-row>
													<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-1 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Diperoleh</div>
														<div class="font-size-10 yellow--text text--darken-3 font-weight-500">{{ komisi.acc | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between" v-if="false">
														<div class="font-size-10 cl-grey">Dibayarkan</div>
														<div class="font-size-10 green--text font-weight-500">{{ komisi.paid | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-4 my-auto d-flex align-center justify-space-between" v-if="false">
														<div class="font-size-10 cl-grey">Saldo</div>
														<div class="font-size-10 blue--text font-weight-500">{{ komisi.saldo | toRupiah }}</div>
													</v-col>
												</v-row>
											</v-col>
										</template>
									</v-row>
								</v-card>
							</template>
						</div>
						
						<!-- Informasi komisi titik clone -->
						<template v-for="(komisi, index) in summaryKomisi.clone">
							<div class="pt-5" :key="index">
								<div class="font-size-12 cl-dark-green font-weight-bold">Kode Mitra {{ komisi.member_ref_network_code }}</div>
								<v-row justify="center" class="mt-1 mb-2 ml-0">
									<v-col cols="12" sm="12" md="4" xl="4" class="pl-0">
										<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow cyan darken-1">
											<v-row>
												<v-col cols="2" sm="1" md="3" lg="2" class="pr-0 my-auto text-right align-center">
													<img class="img-fluid filter-white" src="/assets/icon/total-bonus.png">
												</v-col>
												<v-col cols="10" sm="11" md="9" lg="10" class="pl-sm-5">
													<div class="font-size-13 white--text font-weight-600">{{ komisi.totalAcc | toRupiah }}</div>
													<div class="font-size-10 white--text font-weight-bold">Total Diperoleh</div>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
									<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3 pl-0">
										<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow teal lighten-2" v-if="false">
											<v-row>
												<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
													<img class="img-fluid filter-white" src="/assets/icon/total-dibayarkan.png">
												</v-col>
												<v-col cols="10" sm="9" md="9">
													<div class="font-size-13 white--text font-weight-600">{{ komisi.totalPaid | toRupiah }}</div>
													<div class="font-size-10 white--text font-weight-bold">Total Dibayarkan</div>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
									<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3 pl-0">
										<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow amber darken-2" v-if="false">
											<v-row>
												<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
													<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
												</v-col>
												<v-col cols="10" sm="9" md="9">
													<div class="font-size-13 white--text font-weight-600">{{ komisi.totalBalance | toRupiah }}</div>
													<div class="font-size-10 white--text font-weight-bold">Total Saldo Komisi</div>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
								
								<template v-if="komisi.arrBonus">
									<template v-for="(bonus, idx) in komisi.arrBonus">
										<template v-if="bonus.label !== 'Pasangan Menunggu'">
											<v-card class="px-4 py-3 elevation-0 rounded-xl hover-shadow" :class="{'mt-3': (idx > 0)}" :key="idx + 'a'"   v-if="bonus.label !== 'Sponsor' || userData.member_network_code == komisi.member_ref_network_code">
												<v-row>
													<template v-if="bonus.label == 'Reward'">
														<v-col cols="12" sm="12" md="12" class="my-auto flex-column">
															<div class="d-block">
																<div>
																	<div class="font-size-12 cl-primary font-weight-500">Komisi {{bonus.label}}</div>
																	<v-list outlined rounded dense one-line class="mt-3 rounded-xl">
																		<template v-if="bonus.reward.length > 0">
																			<template v-for="(item, index) in bonus.reward">
																				<v-list-item
																					:key="index"
																					class=""
																				>
																					<v-list-item-content class="pa-0">
																						<v-list-item-title>
																						<!-- desktop view -->
																							<v-row class="d-none d-sm-flex">
																								<v-col cols="12" sm="6" md="6" class="text-left font-size-12">
																									<v-icon dense color="grey" class="mr-2">mdi-circle</v-icon> Reward Peringkat <b>{{ item.reward_qualified_reward_title }}</b> {{ item.reward_qualified_condition_node_left }} : {{ item.reward_qualified_condition_node_left }}
																								</v-col>
																								
																								<v-col cols="12" sm="6" md="6" class="text-right">
																									<div class="font-size-12 dark--text text--darken-1 font-weight-500">{{ item.reward_qualified_reward_value | toRupiah }}</div>
																								</v-col>
																							</v-row>

																							<!-- mobile view -->
																							<v-row class="d-flex d-sm-none">
																								<v-col cols="12" sm="12" md="12" class="d-flex flex-row align-start text-left font-size-10 pr-0 pt-0">
																									<v-icon dense small color="grey" class="mr-3 pt-1">mdi-circle</v-icon>
																									<span class="font-size-10" style="line-height: 150%;">
																										Reward Peringkat<br>
																										<b>{{ item.reward_qualified_reward_title }}</b> {{ item.reward_qualified_condition_node_left }} : {{ item.reward_qualified_condition_node_left }}<br>
																										<div class="d-block pt-2 font-size-12 green--text text--darken-1 font-weight-600">{{ item.reward_qualified_reward_value | toRupiah }}</div>
																									</span>
																								</v-col>
																							</v-row>
																						</v-list-item-title>
																					</v-list-item-content>
																				</v-list-item>
																			</template>
																		</template>
																		<template v-else>
																			<v-list-item>
																				<v-list-item-content class="pa-0">
																					<v-list-item-title>
																						<v-row>
																							<v-col cols="12" sm="12" md="12" class="text-center font-size-10">
																								<span class="d-block text-muted grey--text">Belum ada informasi komisi reward yang tersedia.</span>
																							</v-col>
																						</v-row>
																					</v-list-item-title>
																				</v-list-item-content>	
																			</v-list-item>
																		</template>
																	</v-list>
																</div>
															</div>
														</v-col>
													</template>
													<template v-else>
														<v-col cols="12" sm="12" md="4" class="my-auto flex-column">
															<div class="d-none d-md-flex">
																<div>
																	<div class="font-size-9 cl-grey">Komisi</div>
																	<div class="font-size-12 cl-primary font-weight-500">{{bonus.label}}</div>
																</div>
															</div>

															<div class="d-flex d-md-none">
																<div>
																	<div class="font-size-12 cl-primary font-weight-500">Komisi {{bonus.label}}</div>
																</div>
															</div>
														</v-col>
														<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-none d-md-flex">
															<v-row>
																<template v-if="bonus.label == 'Pasangan'">
																	<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
																		<div class="font-size-10 cl-grey">Dalam Antrian</div>
																		<div class="font-size-12 orange--text text--darken-1 font-weight-500">{{ bonus.balance | toRupiah }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
																		<div class="font-size-10 cl-grey">Potensi Hari ini</div>
																		<div class="font-size-12 orange--text text--darken-1 font-weight-500">{{ getPotency(bonus.label, komisi) | toRupiah }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
																		<div class="font-size-10 cl-grey">Didapat</div>
																		<div class="font-size-12 cyan--text text--darken-1 font-weight-500">{{ bonus.paid | toRupiah }}</div>
																	</v-col>
																</template>
																<template v-else>
																	<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right"></v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
																		<div class="font-size-10 cl-grey">Potensi Hari ini</div>
																		<div class="font-size-12 orange--text text--darken-1 font-weight-500">{{ getPotency(bonus.label, komisi) | toRupiah }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
																		<div class="font-size-10 cl-grey">Didapat</div>
																		<div class="font-size-12 cyan--text text--darken-1 font-weight-500">{{ bonus.acc | toRupiah }}</div>
																	</v-col>
																</template>
																<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto" v-if="false">
																	<div class="font-size-10 cl-grey">Dibayarkan</div>
																	<div class="font-size-12 teal--text text-lighten-2 font-weight-500">{{ bonus.paid | toRupiah }}</div>
																</v-col>
																<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right" v-if="false">
																	<div class="font-size-10 cl-grey">Saldo</div>
																	<div class="font-size-12 cl-primary font-weight-500">{{ bonus.saldo | toRupiah }}</div>
																</v-col>
															</v-row>
														</v-col>
														<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-flex d-md-none">
															<v-row>
																<template v-if="bonus.label == 'Pasangan'">
																	<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-0 my-auto d-flex align-center justify-space-between">
																		<div class="font-size-10 cl-grey">Dalam Antrian</div>
																		<div class="font-size-10 orange--text text--darken-3 font-weight-500">{{ bonus.balance | toRupiah }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-0 my-auto d-flex align-center justify-space-between">
																		<div class="font-size-10 cl-grey">Potensi Hari ini</div>
																		<div class="font-size-10 orange--text text--darken-3 font-weight-500">{{ getPotency(bonus.label, komisi) | toRupiah }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-3 my-auto d-flex align-center justify-space-between">
																		<div class="font-size-10 cl-grey">Didapat</div>
																		<div class="font-size-10 cyan--text text--darken-3 font-weight-500">{{ bonus.paid | toRupiah }}</div>
																	</v-col>
																</template>
																<template>
																	<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-0 my-auto d-flex align-center justify-space-between">
																		<div class="font-size-10 cl-grey">Potensi Hari ini</div>
																		<div class="font-size-10 orange--text text--darken-3 font-weight-500">{{ getPotency(bonus.label, komisi) | toRupiah }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-3 my-auto d-flex align-center justify-space-between">
																		<div class="font-size-10 cl-grey">Didapat</div>
																		<div class="font-size-10 cyan--text text--darken-3 font-weight-500">{{ bonus.acc | toRupiah }}</div>
																	</v-col>
																</template>
																<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between" v-if="false">
																	<div class="font-size-10 cl-grey">Dibayarkan</div>
																	<div class="font-size-10 green--text font-weight-500">{{ bonus.paid | toRupiah }}</div>
																</v-col>
																<v-col cols="12" sm="12" md="4" class="pt-0 pb-4 my-auto d-flex align-center justify-space-between" v-if="false">
																	<div class="font-size-10 cl-grey">Saldo</div>
																	<div class="font-size-10 blue--text font-weight-500">{{ bonus.saldo | toRupiah }}</div>
																</v-col>
															</v-row>
														</v-col>
													</template>
												</v-row>
											</v-card>
										</template>
									</template>
								</template>
							</div>
						</template>
					</v-col>
				</div>
			</template>
		</v-scroll-x-reverse-transition>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: true,
			isActiveMember: false,
			networkType: null,
			limitTransfer: 1500000,
		}
	},
	computed: {
		...mapState('komisi', ['summaryKomisi']),
		...mapState('autentikasi', ['userData']),
	},
	methods: {
		...mapActions('komisi', ['getSummaryKomisi']),

		gotoKomisiTeam() {
			this.$router.push({name: 'detail-komisi-unilevel'})
		},
		formatKomisiLabel(text) {
			if (text) {
				if (text === 'Unilevel') return 'Team'
					else return text.replace('Komisi', '')
				} else {
					return '-'
				}
			},
			async getData() {
				this.loading = await true
			await this.getSummaryKomisi()
			this.loading = false
		},

		getPotency(label, data) {
			let dval = 0
			// if (data.length > 0) {
				data.potency.find(x => {
					if (x.label == label) dval = x.value
				})
			// }

			return dval
		}
	},
	async created(){
		this.$store.dispatch('setPageTitle', `Summary Komisi Premium`)
		this.getData()
	}
};
</script>
